import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center fw-700 mb-1"
}
const _hoisted_3 = {
  class: "btn-group btn-group-sm w-auto mb-2",
  role: "group"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "row"
}
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(['btn btn-outline-primary', { active: _ctx.colorMode === _ctx.ColorModeEnum.TOKEN }]),
            disabled: _ctx.disabled,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setColorMode(_ctx.ColorModeEnum.TOKEN)))
          }, _toDisplayString(_ctx.$t('cms.colorStandard')), 11, _hoisted_4),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(['btn btn-outline-primary', { active: _ctx.colorMode === _ctx.ColorModeEnum.RGBA }]),
            disabled: _ctx.disabled,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setColorMode(_ctx.ColorModeEnum.RGBA)))
          }, _toDisplayString(_ctx.$t('cms.colorCustom')), 11, _hoisted_5)
        ]),
        (_ctx.colorMode === _ctx.ColorModeEnum.TOKEN)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.fullWidth ? 'col-12' : 'col-4')
              }, [
                (_ctx.isBackground)
                  ? (_openBlock(), _createBlock(_component_InputSelect, {
                      key: 0,
                      modelValue: (_ctx.localDto as ColorSolidRestDto).color_code,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => (((_ctx.localDto as ColorSolidRestDto).color_code) = $event)),
                        _ctx.emitModelChanged
                      ],
                      options: _ctx.enumBackgroundColorCode,
                      name: `${_ctx.name} ${_ctx.$t('color')}`,
                      selectText: _ctx.allowEmpty ? _ctx.$t('default') : _ctx.$t('selectText'),
                      errors: _ctx.errors,
                      rules: _ctx.colorRules,
                      canClear: _ctx.allowEmpty,
                      disabled: _ctx.disabled
                    }, null, 8, ["modelValue", "options", "name", "selectText", "errors", "rules", "canClear", "disabled", "onUpdate:modelValue"]))
                  : (_openBlock(), _createBlock(_component_InputSelect, {
                      key: 1,
                      modelValue: (_ctx.localDto as TextColorSolidRestDto).text_color_code,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => (((_ctx.localDto as TextColorSolidRestDto).text_color_code) = $event)),
                        _ctx.emitModelChanged
                      ],
                      options: _ctx.enumTextColorCode,
                      name: `${_ctx.name} ${_ctx.$t('color')}`,
                      selectText: _ctx.allowEmpty ? _ctx.$t('default') : _ctx.$t('selectText'),
                      errors: _ctx.errors,
                      rules: _ctx.colorRules,
                      canClear: _ctx.allowEmpty,
                      disabled: _ctx.disabled
                    }, null, 8, ["modelValue", "options", "name", "selectText", "errors", "rules", "canClear", "disabled", "onUpdate:modelValue"]))
              ], 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.colorMode === _ctx.ColorModeEnum.RGBA && _ctx.localDto.rgba)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_ColorPicker, {
                modelValue: _ctx.localDto.rgba,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDto.rgba) = $event)),
                  _ctx.emitModelChanged
                ],
                label: _ctx.$t('color'),
                name: `${_ctx.name} ${_ctx.$t('color')}`,
                label_bold: false,
                read_only: _ctx.disabled
              }, null, 8, ["modelValue", "label", "name", "read_only", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}